<template>
    <div>
      <AllRequirement :showSearch="true" :tableList="demandList" :total="total" :showPage="true" @handleQueryChange="demandQueryChange"></AllRequirement>
    </div>
</template>

<script>
import AllRequirement from "./allRequirement";
import {getDemandsByPage, getShopList, webStoreTree} from '../../utils/interface';

    export default {
        //   需求展示
        name: "printShopResults",
        components: {AllRequirement},
        data() {
            return {
                uuid: '',
                userUuid: '',
                total: 0,
                pageSize:9,
                productName:'',
                demandList:[]
            };
        },
        created() {
        },
        methods: {
            init(userUuid){
                this.userUuid = userUuid;
                let params = {
                    demandName: this.productName,
                    currentPage: 1,
                    pageSize: this.pageSize,
                    creator:this.userUuid,
                };
                this.getShopList(params);
            },
            demandQueryChange(info){
                console.log("需求列表查询参数",info)
                let params = {
                    demandName: info.productName,
                    currentPage: info.current,
                    pageSize: info.pageSize,
                    creator:this.userUuid,
                };
                this.getShopList(params)
            },
            getShopList(params) {
              this.demandList=[];
              getDemandsByPage(params).then((res) => {
                    this.demandList = res.data.records;
                    this.total = parseInt(res.data.total);
                    window.scrollTo(0,0);
                });
            },
        },
    };
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/print/demandList.vue